import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CATALOG_URL, SITE_URL } from "../../config/site";
import SEO from "../../components/SEO";
import Toast from "../../components/Toast";
import PhotoPreviewGrid from "../../components/PhotoPreviewGrid";
import PhotoDropzone from "../../components/PhotoDropzone";
import PhotoActions from "../../components/PhotoActions";
import PhotoPackInfo from "../../components/PhotoPackInfo";
import PhotoCropModal from "../../components/PhotoCropModal";

import { MAX_PHOTOS } from "../../constants/photoProduct";
import { usePhotoUploadPage } from "../../hooks/usePhotoUploadPage";
import { getCurrentPack } from "../../utils/getCurrentPack";

import Header from "../../components/layout/Header";
import Footer from "../../components/layout/Footer";

import "./PhotoUploadPage.css";

export default function PhotoUploadPage() {
  const [photoPacks, setPhotoPacks] = useState([]);
  const {
    toast,

    photos,

    cropPhoto,

    inputRef,

    handleInputChange,
    handleDrop,

    removePhoto,

    closeCrop,
    confirmCrop,

    handleClear,
    handleSubmit,
  } = usePhotoUploadPage(photoPacks);

  const currentPack = getCurrentPack(photos.length, photoPacks);
  useEffect(() => {
    async function loadPhotoPacks() {
      try {
        const response = await fetch(CATALOG_URL);
        const data = await response.json();

        const packs = data.products
          .filter((product) => product.active)
          .filter((product) => product.category === "photo_magnets")
          .filter((product) => product.type === "pack")
          .sort((a, b) => a.order - b.order);

        setPhotoPacks(packs);
      } catch (error) {
        console.error("Error loading photo packs:", error);
      }
    }

    loadPhotoPacks();
  }, []);

  return (
    <>
<SEO
  title="Editor de fotoimanes 5x5 cm | Imalandia"
  description="Sube y encuadra tus imágenes en el editor de Imalandia para preparar tu pack de fotoimanes artesanales de 5x5 cm."
  canonical={`${SITE_URL}/fotos`}
/>
      <Header />

      <div className="photo-page">
        <Toast message={toast} />

        <section className="photo-hero">
          <p className="photo-badge">📸 Crea tus imanes</p>

          <h1>Sube tus fotos para crear tus imanes</h1>

          <p>
            Selecciona tus imágenes, revisa la vista previa y prepara tu pedido.
          </p>
        </section>

        <section className="photo-card">
          <PhotoDropzone
            inputRef={inputRef}
            onInputChange={handleInputChange}
            onDrop={handleDrop}
          />

          <p className="photo-counter">
            {photos.length} / {MAX_PHOTOS} fotos
          </p>

          <PhotoPreviewGrid photos={photos} removePhoto={removePhoto} />
          <PhotoPackInfo packs={photoPacks} />
          <PhotoActions
            onClear={handleClear}
            onSubmit={handleSubmit}
            submitLabel="Anadir al carrito"
          />

          {currentPack && (
            <div className="photo-current-pack">
              <strong>{currentPack.name}</strong>

              <span>{currentPack.price.toFixed(2)} €</span>
            </div>
          )}

          <p className="photo-after-action-note">
            Para otras cantidades, consúltanos.
          </p>

          <div className="photo-info-box">
            <p>
              Los imanes personalizados incluyen tus fotos impresas. Si además
              quieres un marco decorativo para colocarlos o presentarlos, puedes
              verlo en la página de marcos.
            </p>

            <Link to="/marcos">Ver marcos decorativos</Link>
          </div>
        </section>

        {cropPhoto && (
          <PhotoCropModal
            image={cropPhoto}
            onClose={closeCrop}
            onConfirm={confirmCrop}
          />
        )}
      </div>

      <Footer />
    </>
  );
}
